<!--今日客户任务-->
<template>
  <article>
    <div class="tab-service" ref="header">
      <ul class="tab-service-detail">
        <li :class="{'on':type==='task'}" @click="onShiftTap('task')"><a href="javascript:void(0);">任务</a></li>
        <li :class="{'on':type==='customer'}" @click="onShiftTap('customer')"><a href="javascript:void(0);">客户</a></li>
      </ul>
    </div>

    <!-- height要算准确 -->
    <scroller
      lock-x scrollbar-y
      use-pullup
      ref="myScroller"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
        <group v-show="type==='task'" v-for="(item,index) in taskList" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名：{{item.customer_name}}<span class="label">{{item.intention_level}}级</span></p>
            <a slot="value" class="phone-icon-right" :href="`tel:${item.mobile}`" @click.stop="makeACall(item.customer_id,item.id,item.assignee_id)"></a>
          </cell>
          <cell class="personal-info-detail personal-info-value">
            <div slot="after-title" class="title-list">
              <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <span slot="value" class="info info2">已联系<span class="red">{{item.call_count}}</span>次</span>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">下次致电：{{timeTransform(item.next_contact_at)}}</p>
            <p slot="after-title" class="info">最近联系：{{item.last_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
            <em class="icon-done" v-if="item.is_complete"></em>
          </cell>
          <cell class="personal-info-detail">
            <p slot="after-title">当前任务：第<span class="red">{{item.sequence}}</span>次，共<span class="red">{{item.total_task_count}}</span>次任务</p>
          </cell>
        </group>
        <group v-show="type==='customer'" v-for="(item,index) in customerList" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名{{item.customer_name}}<span class="label">{{item.intention_level}}级</span></p>
            <a slot="value" class="phone-icon-right" :href="`tel:${item.mobile}`"></a>
          </cell>
          <cell class="personal-info-detail" @click.native="toArchives(item.id)">
            <div slot="after-title" class="title-list">
              <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">下次致电：{{timeTransform(item.next_contact_at)}}</p>
            <p slot="after-title" class="info">最近联系：{{item.last_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
          </cell>
        </group>
        <p class="tip-text1">共有{{totalCount}}{{type === 'task' ? '条任务待跟进' : '位客户待跟进'}}</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'
import callMixins from '../../mixins/call.mixins'
import authApi from '../../../common/auth'

export default {
  mixins: [callMixins],
  components: {
    Scroller,
    Cell,
    Group
  },
  data() {
    return {
      pageAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      authId: '',
      // 客户跟进权限
      followCustomerAuth: false,
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      type: 'task',
      mobile: '',
      totalCount: 0,
      totalPage: 1,
      item_per_page: 20,
      page: 1,
      time_interval: 1,
      taskList: [],
      customerList: [],
      scrollerHeight: ''
    }
  },
  mounted() {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.$store.state.promiseAuth.then(auth => {
      let authList = auth.authList
      this.authId = auth.id
      let permission = authApi.haveSomeAuth(this.pageAuth, authList)
      this.followCustomerAuth = authList.includes(authApi.saleManage.sale_potential_customer_follow_up)
      if (permission) {
        this.getTasksList()
        this.getRecordAuth()
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    loadMore(done) {
      if (this.page < this.totalPage) {
        ++this.page
        if (this.type === 'task') {
          this.$rest.saleManage.todayCustomerTaskTask({
            page: this.page,
            mobile: this.mobile,
            item_per_page: this.item_per_page,
            time_interval: this.time_interval
          }).then(res => {
            if (res.code === 0) {
              this.taskList.push(...res.data.tasks)
              this.totalCount = res.data.total
              this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
              done(100)
            }
          })
        } else {
          this.$rest.saleManage.todayCustomerTaskCustomer({
            page: this.page,
            item_per_page: this.item_per_page
          }).then(res => {
            if (res.code === 0) {
              this.customerList.push(...res.data.customers)
              this.totalCount = res.data.total
              this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
              done(100)
            }
          })
        }
      } else {
        done()
      }
    },
    getTasksList() {
      this.$rest.saleManage.todayCustomerTaskTask({
        page: this.page,
        mobile: this.mobile,
        item_per_page: this.item_per_page,
        time_interval: this.time_interval
      }).then(res => {
        if (res.code === 0) {
          this.taskList = res.data.tasks
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    getCustomerList() {
      this.$rest.saleManage.todayCustomerTaskCustomer({
        page: this.page,
        item_per_page: this.item_per_page
      }).then(res => {
        if (res.code === 0) {
          this.customerList = res.data.customers
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    onShiftTap(type) {
      if (this.type === type) return
      this.type = type
      this.page = 1
      if (this.type === 'task') {
        this.taskList = []
        this.getTasksList()
      } else if (this.type === 'customer') {
        this.customerList = []
        this.getCustomerList()
      }
    },
    makeACall(customerId, id, assigneeId) {
      if (this.authId === assigneeId) {
        cache.clearSessionData('addCustomerRecordLocalData')
        this.initCall({
          interval: 1000,
          threshold: 0,
          complete: (startTime, endTime) => {
            this.$router.push({
              path: '/salemanage/staff/addcustomerrecord/' + customerId,
              query: { call_duration: endTime - startTime, customer_task_id: id }
            })
          }
        })
      }
    },
    timeTransform(str) {
      if (!str) return ''
      let date = new Date(str.replace(/-/g, '/'))
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    toArchives(id) {
      cache.clearSessionData('customerArchivesLocalData')
      this.$router.push({ path: '/salemanage/staff/customerarchives', query: { id: id } })
    }
  }
}

</script>
<style lang="less">
@import "../../../stylesheets/modules/salemanage/sale";

</style>
